import React from 'react';
import { CompactSelect } from '../properties/CompactPropertyFields';
import { useLocalizedMessage } from '../../../../util/useLocalizedMessage';
import styles from './SearchViewSelect.module.scss';

const viewLabels = {
  searchBox: 'searchInterface.workspace.searchBox', dropdown: 'searchInterface.workspace.dropdown',
  resultsPage: 'searchInterface.workspace.resultsPage', product: 'searchInterface.workspace.productPage',
};

export default function SearchViewSelect({ config, view, onChange, disabled }) {
  const t = useLocalizedMessage();
  const views = Object.keys(config?.search?.views || {});
  return <div className={styles.control}><CompactSelect title={t('searchInterface.workspace.view')}
    value={views.includes(view) ? view : (views[0] || '')} disabled={disabled}
    items={views.map(value => ({ value, text: viewLabels[value] ? t(viewLabels[value]) : value }))}
    onChange={onChange} /></div>;
}
